import { ChangeDetectionStrategy, Component, Input, EventEmitter, Output } from '@angular/core';
import { DropdownMenuWithIconsService } from '@shared/dropdown-menu-with-icons/dropdown-menu-with-icons.service';
import { DropdownMenuItem } from 'mojo-abstract-dropdown-menu';
import { Elevations } from 'mojo-card';
import { TalentPool } from 'mojo-talent-pools';

@Component({
  selector: 'mojo-talent-pools-item',
  templateUrl: './talent-pools-item.component.html',
  styleUrls: ['./talent-pools-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TalentPoolsItemComponent {
  elevation = Elevations.first;
  @Input() talentPool: TalentPool;
  @Input() indexOfElement: number;
  @Input() page = 0;
  @Input() numberOfElements = 0;

  @Output()
  elementToPin = new EventEmitter<Object>();

  menuItems: DropdownMenuItem[] = [this.dropdownMenuWithIconsService.removeTalentPool()];

  constructor(private dropdownMenuWithIconsService: DropdownMenuWithIconsService) {}

  pinPool() {
    this.elementToPin.emit({
      fromIndex: this.indexOfElement,
      pinnedStatus: !this.talentPool.pin,
    });
  }
}
